const filterExistingDocuments = (newDocs, existingDocs = []) => {
  return (newDocs || []).filter(
    (doc) => !existingDocs.some((existingDoc) => existingDoc.id === doc.id),
  )
}

export default filterExistingDocuments
